import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, finalize, map, startWith, switchMap } from "rxjs/operators";
import { Dossier } from '../../core/model/dossier';
import { DossierService } from '../../core/service/dossier.service';
import { PortefeuilleTabsComponent } from '../portefeuille-tabs/portefeuille-tabs.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbdModalConfirm } from 'src/app/core/services/utils/modal-confirm';

@Component({
  selector: "app-portefeuille",
  templateUrl: "./portefeuille.component.html",
  styleUrls: ["./portefeuille.component.scss"]
})
export class PortefeuilleComponent implements OnInit {
  dossiers: Dossier[];

  displayedColumns: string[] = [
    "numDossier",
    "typeDossier",
    "nomClient",
    "montantPret",
    "resteAPayer",
    "dateMiseEnPlace",
    "statutDossier",
    "impayeJour",
    "actions"
  ];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private modalService: NgbModal,
    private _router: Router,
    private _dossierService: DossierService,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    this.getPageDossier("_", 0);
  }

  getPageDossier(filter: String, pageIndex: number): void {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = pageIndex)
    );

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this._dossierService.findAllPaging(
            filter,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe(data => (this.dossiers = data));
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getPageDossier(filterValue, 0);
  }

  voirEcheance(numDossier): void {
    this._router.navigate(["/suivi-portefeuille/detail-dossier/" + numDossier]);
  }


  suiviPortefeuilleClient(numDossier: String): void {
    const modalRef = this.modalService.open(PortefeuilleTabsComponent, {
      centered: true,
      windowClass: "suivi-portefeuille-client-modal-class"
    });
    modalRef.componentInstance.numDossier = numDossier;

    modalRef.result.then(
      data => {
        // on close
      },
      reason => {
        // on dismiss
      }
    );
  }

}
